const InputCustom = ({
    label,
    placeholder,
    value,
    error,
    right,
    left,
    onChange,
    id,
}: {
    id: string;
    label: string;
    placeholder: string;
    value: string;
    error?: boolean;
    right?: string;
    left?: string;
    onChange: (value: string) => void;
}) => {
    return (
        <div className={`form-group bg-none margin-0 padding-0 width-100pct ${error ? 'has-error' : ''}`}>
            <label htmlFor={id}>{label}</label>
            <div className="input-group">
                {left ? <span className={`input-group-addon ${error ? 'border-color-danger': ''}`}>{left}</span> : null}
                <input
                    id={id}
                    className="form-control has-error"
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => {
                        onChange(e.target.value);
                    }}
                />
                {right ? <span className={`input-group-addon ${error ? 'border-color-danger': ''}`}>{right}</span> : null}
            </div>
        </div>
    );
};

export default InputCustom;